import React from "react";
import { useParams } from 'react-router-dom';
import Card from "components/card";
import { connect } from "react-redux";
import ScheduleForm from "../schedules/components/ScheduleForm";
import EmployeeProfile from "../components/EmployeeProfile";
import avatar from "assets/img/avatars/user.png";
import { 
	getEmployeeScheduleDetails
} from "../../../../redux/employee/employeeState";

const ViewEmployeeSchedule = () => { 
    const { employeeId, scheduleId } = useParams();


    return (
        <div className="mt-3">
            <div className="mt-5 grid h-full grid-cols-1 gap-4">
                <Card extra={"w-full h-full p-4"}>
                    <div className="mb-4">
						<EmployeeProfile avatar={avatar} withDesignation={true} recordId={employeeId}/>
					</div>
                    <div className="content-wrapper p-5 mb-2 rounded-lg shadow-md">
                        <ScheduleForm recordId={scheduleId} employeeId={employeeId} mode="view" />
                    </div>
                </Card>
          </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    recordData: state.employee.employeeScheduleDetails?.data,
	requesting: state.employee.employeeScheduleDetails?.requesting,
	success: state.employee.employeeScheduleDetails?.succcess,
});

const mapDispatchToProps = (dispatch) => ({
    getRecord: (id) => dispatch(getEmployeeScheduleDetails(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ViewEmployeeSchedule);